import { render, staticRenderFns } from "./SourcingReasonsRenderer.vue?vue&type=template&id=2b70a198&scoped=true&"
import script from "./SourcingReasonsRenderer.vue?vue&type=script&lang=js&"
export * from "./SourcingReasonsRenderer.vue?vue&type=script&lang=js&"
import style0 from "./SourcingReasonsRenderer.vue?vue&type=style&index=0&id=2b70a198&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b70a198",
  null
  
)

/* custom blocks */
import block0 from "./SourcingReasonsRenderer.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports